// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"styles_mainPage__2nz1j","imgWrapper":"styles_imgWrapper__2FppN"};